export function UserMealListRowIngredients({ ingredients }) {
  if (!ingredients.length) return null;

  return (
    <div className="border-t border-gray-100 px-4 py-3 bg-gray-50">
      <p className="text-xs font-medium text-gray-400 uppercase tracking-wide mb-2.5">
        Ingredients
      </p>
      <div className="flex flex-wrap gap-2">
        {ingredients.map((ingredient) => (
          <div
            key={ingredient.ingredientId}
            className="flex items-center gap-1 px-2.5 py-1 bg-white border border-gray-200 rounded-full text-sm"
          >
            <span className="text-gray-400 text-xs">
              {ingredient.ingredientQuantity} {ingredient.ingredientUnit}
            </span>
            <span className="text-gray-800">{ingredient.ingredientName}</span>
          </div>
        ))}
      </div>
    </div>
  );
}
